module.exports = __webpack_public_path__ + "img/localadventures-payments-cop.abd4018.svg";